import styled from "styled-components"
import { getAllPosts, getPostBySlug } from "../../lib/api/postsApi"
import markdownToHtml from "../../lib/markdownToHtml"
import { useRouter } from "next/router"
import { PostPreview } from "../../components/PostPreview"
import {
  APP_DESCRIPTION,
  APP_KEYWORDS,
  APP_TITLE,
  APP_URL,
  revalidateNext,
} from "../../utils/constants"
import MetaTags from "../MetaTags"
import React from "react"

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export default function Post({ post }) {
  const router = useRouter()

  // if (!router.isFallback && !post?.slug) {
  //   return <ErrorPage statusCode={404} />
  // }
  return (
    <StyledContainer>
      {router.isFallback ? (
        <div>Loading…</div>
      ) : (
        <>
          <MetaTags
            title={post?.title}
            description={post.excerpt}
            url={`${APP_URL}/posts/${post?.slug}`}
            keywords={APP_KEYWORDS}
          />
          <PostPreview item={post} />
        </>
      )}
    </StyledContainer>
  )
}

export async function getStaticProps({ params }) {
  const post = getPostBySlug(params.slug, [
    "title",
    "date",
    "slug",
    "author",
    "content",
    "ogImage",
    "coverImage",
    "tags",
  ])
  const content = await markdownToHtml(post.content || "")

  return {
    props: {
      post: {
        ...post,
        content,
      },
      slug: params.slug,
    },
    revalidate: revalidateNext,
  }
}

export async function getStaticPaths() {
  const posts = getAllPosts(["slug"], null)
  return {
    paths: posts.map((post) => {
      return {
        params: {
          slug: post.slug,
        },
      }
    }),
    fallback: false,
  }
}
